// extracted by mini-css-extract-plugin
export default {"games_section_headline":"notification_games_section_headline__X0ppB","games_section_title":"notification_games_section_title__5pceC"};